import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";
import { cn } from "@/lib/utils";

export function SectionHeading({ eyebrow, title, description, link, className = "", size = "xl", titleTestId }) {
  return (
    <Reveal className={cn("flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between", className)}>
      <div className="max-w-3xl">
        {eyebrow && <div className="eyebrow">{eyebrow}</div>}
        <h2 className={cn("mt-4 text-foreground", size === "xl" ? "display-xl" : "display-lg")} data-testid={titleTestId}>
          {title}
        </h2>
        {description && <p className="mt-5 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg">{description}</p>}
      </div>
      {link && (
        <Link
          to={link.to}
          className="group inline-flex items-center gap-2 font-mono text-[11px] font-medium uppercase tracking-mono text-muted-foreground transition-colors duration-200 hover:text-foreground"
          data-testid={link.testId}
        >
          {link.label}
          <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" strokeWidth={1.5} />
        </Link>
      )}
    </Reveal>
  );
}
